"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselNavigatorItem = exports.CarouselNavigator = exports.CarouselArrow = exports.CarouselItem = exports.CarouselFade = exports.CarouselSlide = exports.Carousel = exports.CarouselContext = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var utils_1 = require("@react-aria/utils");

var components_animation_1 = require("@conte-ltd/components-animation");

var components_utils_1 = require("@conte-ltd/components-utils");

var use_carousel_controller_1 = require("./use-carousel-controller");

var components_button_1 = require("@conte-ltd/components-button");

exports.CarouselContext = (0, react_2.createContext)(null);

function _Carousel(props, fwRef) {
  var ref = (0, use_carousel_controller_1.useCarouselController)().ref;

  var _a = __read((0, react_2.useState)(0), 2),
      activeIndex = _a[0],
      setActiveIndex = _a[1];

  var _b = __read((0, react_2.useState)(0), 2),
      beforeActiveIndex = _b[0],
      setBeforeActiveIndex = _b[1];

  return (0, jsx_runtime_1.jsx)(exports.CarouselContext.Provider, __assign({
    value: {
      activeIndex: activeIndex,
      setActiveIndex: setActiveIndex,
      beforeActiveIndex: beforeActiveIndex,
      setBeforeActiveIndex: setBeforeActiveIndex,
      controllerRef: ref
    }
  }, {
    children: (0, jsx_runtime_1.jsx)("div", __assign({
      css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          position: relative;\n        "], ["\n          position: relative;\n        "]))),
      ref: fwRef
    }, props), void 0)
  }), void 0);
}

exports.Carousel = (0, react_2.forwardRef)(_Carousel);

function _CarouselSlide(props, fwRef) {
  var _a, _b;

  var childrenNode = props.children,
      _c = props.slidesToShow,
      slidesToShow = _c === void 0 ? 1 : _c,
      _d = props.slidesToScroll,
      slidesToScroll = _d === void 0 ? 1 : _d,
      autoPlay = props.autoPlay,
      _e = props.infinite,
      infinite = _e === void 0 ? true : _e,
      _f = props.duration,
      duration = _f === void 0 ? 3000 : _f,
      _g = props.speed,
      speed = _g === void 0 ? 300 : _g,
      _h = props.slideScale,
      slideScale = _h === void 0 ? 1 : _h,
      centerMode = props.centerMode,
      solidMode = props.solidMode,
      onBeforeChange = props.onBeforeChange,
      onAfterChange = props.onAfterChange;
  var context = (0, react_2.useContext)(exports.CarouselContext);
  (0, components_utils_1.assertIsDefined)(context, 'CarouselSlideコンポーネントはCarouselコンポーネントの配下に存在する必要があります');
  var controllerRef = context.controllerRef,
      activeIndex = context.activeIndex,
      setActiveIndex = context.setActiveIndex,
      beforeActiveIndex = context.beforeActiveIndex,
      setBeforeActiveIndex = context.setBeforeActiveIndex;
  var isAnimating = beforeActiveIndex !== activeIndex;

  var _j = __read((0, react_2.useState)(), 2),
      lastOffset = _j[0],
      setLastOffset = _j[1];

  var ref = (0, react_2.useRef)(null);

  var _k = (0, components_animation_1.useAnimationController)(),
      animationRef = _k.ref,
      animate = _k.animate;

  var children = (0, react_2.useMemo)(function () {
    return react_2.Children.toArray(childrenNode);
  }, [childrenNode]);
  var containerRef = (0, react_2.useRef)(null);
  var containerRect = (0, components_utils_1.useRect)(containerRef);
  var slideWidth = ((_a = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) !== null && _a !== void 0 ? _a : 0) * slideScale / slidesToShow;
  var slidesCount = infinite ? children.length * 2 : children.length;
  var nextSlidesNum = Math.floor(slidesCount / 2);
  var prevSlidesNum = nextSlidesNum - slidesCount + 1;
  var leftOffset = (centerMode ? slideWidth * (prevSlidesNum + Math.floor((slidesToShow - 1) / 2)) : slideWidth * prevSlidesNum) + ((_b = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) !== null && _b !== void 0 ? _b : 0) * (1 - slideScale) / 2;

  var slideAnimation = function slideAnimation(slideIndex) {
    var offset = leftOffset + slideWidth * slideIndex;
    animate({
      id: slideIndex === 0 ? 'cancel' : 'slide',
      keyframes: {
        left: offset + "px"
      },
      options: {
        fill: 'both',
        duration: speed
      }
    });
    setBeforeActiveIndex(function (prev) {
      var tmp = prev - slideIndex;
      var next = tmp < slidesCount ? tmp >= 0 ? tmp : slidesCount + tmp : tmp - slidesCount;

      if (prev !== next) {
        onBeforeChange === null || onBeforeChange === void 0 ? void 0 : onBeforeChange((0, components_utils_1.wrapInRange)(next, children.length), (0, components_utils_1.wrapInRange)(prev, children.length));
      }

      return next;
    });
  };

  var _l = autoPlay ? (0, components_utils_1.useInterval)(function () {
    slideAnimation(-slidesToScroll);
  }, duration + speed) : {
    clear: function clear() {},
    set: function set() {}
  },
      clear = _l.clear,
      set = _l.set;

  var clonedChildren = (0, react_2.useMemo)(function () {
    return (0, components_utils_1.range)(prevSlidesNum, nextSlidesNum + 1).map(function (order) {
      var i = activeIndex + order;
      var index = (0, components_utils_1.wrapInRange)(i, children.length);
      var child = children[index];

      if ((0, react_2.isValidElement)(child)) {
        return (0, react_2.cloneElement)(child, {
          key: i,
          style: {
            order: order,
            transition: "transform " + speed / 1000 + "s ease-in",
            transform: solidMode && index !== (0, components_utils_1.wrapInRange)(beforeActiveIndex, children.length) ? 'scale(0.9)' : undefined
          }
        });
      }
    });
  }, [children, activeIndex, beforeActiveIndex, prevSlidesNum, nextSlidesNum]);
  (0, react_2.useImperativeHandle)(controllerRef, function () {
    return {
      play: function play() {
        set();
      },
      stop: function stop() {
        clear();
      },
      prev: function prev() {
        if (isAnimating) {
          return;
        }

        clear();
        slideAnimation(slidesToScroll);
      },
      next: function next() {
        if (isAnimating) {
          return;
        }

        clear();
        slideAnimation(-slidesToScroll);
      },
      paginateTo: function paginateTo(index) {
        if (isAnimating) {
          return;
        }

        clear();
        slideAnimation((0, components_utils_1.wrapInRange)(activeIndex - index, infinite ? 1 - children.length : 0, children.length));
      },
      getIndex: function getIndex() {
        return activeIndex;
      },
      count: function count() {
        return children.length;
      }
    };
  });
  return (0, jsx_runtime_1.jsx)(components_animation_1.GestureAnimation, __assign({
    onDrag: function onDrag(_a) {
      var animate = _a.animate,
          _b = __read(_a.xy, 1),
          x = _b[0],
          _c = __read(_a.movement, 1),
          mx = _c[0],
          _d = __read(_a.swipe, 1),
          sx = _d[0],
          first = _a.first,
          last = _a.last,
          cancel = _a.cancel,
          canceled = _a.canceled;

      if (canceled) {
        return;
      }

      if (isAnimating) {
        cancel();
        return;
      }

      if (first) {
        clear();
        return;
      }

      if (last || x < containerRect.left || containerRect.right < x) {
        cancel();
        var rect = (0, components_utils_1.getRect)(ref);
        var thresholdRange = slideWidth * slidesToScroll;
        var prevThreshold = containerRect.left + leftOffset;
        var nextThreshold = prevThreshold + thresholdRange;
        var cursor = rect.left + thresholdRange / 2;

        if (cursor > nextThreshold) {
          slideAnimation(Math.floor((cursor - prevThreshold) / thresholdRange) * slidesToScroll);
        } else if (cursor < prevThreshold) {
          slideAnimation(-Math.floor((nextThreshold - cursor) / thresholdRange) * slidesToScroll);
        } else {
          slideAnimation(sx * slidesToScroll);
        }

        setLastOffset(mx);
        return;
      }

      animate({
        id: 'gesture',
        keyframes: {
          left: mx + "px"
        },
        options: {
          fill: 'both'
        }
      });
    },
    onFinish: function onFinish(_a) {
      var animation = _a.animation;

      if (animation.id === 'slide' || animation.id === 'cancel') {
        animate({
          id: 'initial',
          keyframes: {
            left: leftOffset + "px"
          },
          options: {
            fill: 'both'
          }
        });
        setLastOffset(leftOffset);
        setActiveIndex(function (prev) {
          var next = beforeActiveIndex;

          if (prev !== next) {
            onAfterChange === null || onAfterChange === void 0 ? void 0 : onAfterChange((0, components_utils_1.wrapInRange)(next, children.length), (0, components_utils_1.wrapInRange)(prev, children.length));
          }

          return next;
        });
        set();
      }
    },
    config: {
      drag: {
        initial: function initial() {
          var _a, _b, _c;

          var left = (_b = (_a = (0, components_utils_1.getRect)(ref)) === null || _a === void 0 ? void 0 : _a.left) !== null && _b !== void 0 ? _b : 0;
          var parentLeft = (_c = containerRect === null || containerRect === void 0 ? void 0 : containerRect.left) !== null && _c !== void 0 ? _c : 0;
          return [left - parentLeft, 0];
        },
        useTouch: true,
        axis: 'x',
        swipeDuration: Infinity
      }
    },
    ref: animationRef
  }, {
    children: function children(_a) {
      var innerRef = _a.ref,
          other = __rest(_a, ["ref"]);

      return (0, jsx_runtime_1.jsx)("div", __assign({
        css: (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            position: relative;\n            overflow: hidden;\n            width: 100%;\n            height: 100%;\n\n            & > [data-slider] {\n              position: relative;\n              display: flex;\n            }\n          "], ["\n            position: relative;\n            overflow: hidden;\n            width: 100%;\n            height: 100%;\n\n            & > [data-slider] {\n              position: relative;\n              display: flex;\n            }\n          "]))),
        ref: containerRef
      }, (0, utils_1.mergeProps)((0, components_utils_1.styleProps)(props)), {
        children: (0, jsx_runtime_1.jsx)("div", __assign({
          "data-slider": true,
          style: {
            left: (lastOffset !== null && lastOffset !== void 0 ? lastOffset : leftOffset) + "px",
            width: slideWidth * slidesCount + "px"
          },
          ref: (0, components_utils_1.mergeRefs)([fwRef, ref, innerRef])
        }, other, {
          children: clonedChildren
        }), void 0)
      }), void 0);
    }
  }), void 0);
}

exports.CarouselSlide = (0, react_2.forwardRef)(_CarouselSlide);

function _CarouselFade(props, fwRef) {
  var childrenNode = props.children,
      autoPlay = props.autoPlay,
      _a = props.infinite,
      infinite = _a === void 0 ? true : _a,
      _b = props.duration,
      duration = _b === void 0 ? 3000 : _b,
      _c = props.speed,
      speed = _c === void 0 ? 300 : _c,
      onBeforeChange = props.onBeforeChange,
      onAfterChange = props.onAfterChange;
  var context = (0, react_2.useContext)(exports.CarouselContext);
  (0, components_utils_1.assertIsDefined)(context, 'CarouselFadeコンポーネントはCarouselコンポーネントの配下に存在する必要があります');
  var controllerRef = context.controllerRef,
      activeIndex = context.activeIndex,
      setActiveIndex = context.setActiveIndex,
      beforeActiveIndex = context.beforeActiveIndex,
      setBeforeActiveIndex = context.setBeforeActiveIndex;
  var isAnimating = beforeActiveIndex !== activeIndex;
  var ref = (0, react_2.useRef)(null);
  var children = (0, react_2.useMemo)(function () {
    return react_2.Children.toArray(childrenNode);
  }, [childrenNode]);
  var containerRect = (0, components_utils_1.useRect)(ref);

  var fadeAnimation = function fadeAnimation(slideIndex) {
    if (slideIndex === 0) {
      return;
    }

    setBeforeActiveIndex(function (prev) {
      var tmp = prev - slideIndex;
      var next = (0, components_utils_1.wrapInRange)(tmp, children.length);

      if (prev !== next) {
        onBeforeChange === null || onBeforeChange === void 0 ? void 0 : onBeforeChange(next, prev);
      }

      setTimeout(function (next) {
        setActiveIndex(function (prev) {
          if (prev !== next) {
            onAfterChange === null || onAfterChange === void 0 ? void 0 : onAfterChange((0, components_utils_1.wrapInRange)(next, children.length), (0, components_utils_1.wrapInRange)(prev, children.length));
          }

          return next;
        });
        set();
      }, speed, next);
      return next;
    });
  };

  var _d = autoPlay ? (0, components_utils_1.useInterval)(function () {
    fadeAnimation(-1);
  }, duration + speed) : {
    clear: function clear() {},
    set: function set() {}
  },
      clear = _d.clear,
      set = _d.set;

  var clonedChildren = (0, react_2.useMemo)(function () {
    return (0, components_utils_1.range)(0, children.length).map(function (index) {
      var child = children[index];

      if ((0, react_2.isValidElement)(child)) {
        return (0, react_2.cloneElement)(child, {
          key: index,
          style: {
            order: index === beforeActiveIndex ? 1 : 0,
            gridColumn: '1',
            gridRow: '1',
            opacity: index === beforeActiveIndex ? 1 : 0,
            transition: "opacity " + speed / 1000 + "s"
          }
        });
      }
    });
  }, [children, beforeActiveIndex]);
  (0, react_2.useImperativeHandle)(controllerRef, function () {
    return {
      play: function play() {
        set();
      },
      stop: function stop() {
        clear();
      },
      prev: function prev() {
        if (isAnimating) {
          return;
        }

        clear();
        fadeAnimation(1);
      },
      next: function next() {
        if (isAnimating) {
          return;
        }

        clear();
        fadeAnimation(-1);
      },
      paginateTo: function paginateTo(index) {
        if (isAnimating) {
          return;
        }

        clear();
        fadeAnimation((0, components_utils_1.wrapInRange)(activeIndex - index, children.length));
      },
      getIndex: function getIndex() {
        return activeIndex;
      },
      count: function count() {
        return children.length;
      }
    };
  });
  return (0, jsx_runtime_1.jsx)(components_animation_1.GestureAnimation, __assign({
    onDrag: function onDrag(_a) {
      var _b = __read(_a.xy, 1),
          x = _b[0],
          _c = __read(_a.swipe, 1),
          sx = _c[0],
          first = _a.first,
          last = _a.last,
          cancel = _a.cancel,
          canceled = _a.canceled;

      if (canceled) {
        return;
      }

      if (isAnimating) {
        cancel();
        return;
      }

      if (first) {
        clear();
        return;
      }

      if (last) {
        fadeAnimation(sx);
      }

      if (x < containerRect.left || containerRect.right < x) {
        cancel();
        return;
      }
    },
    config: {
      drag: {
        useTouch: true,
        axis: 'x',
        swipeDuration: Infinity
      }
    }
  }, {
    children: function children(_a) {
      var innerRef = _a.ref,
          other = __rest(_a, ["ref"]);

      return (0, jsx_runtime_1.jsx)("div", __assign({
        css: (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            position: relative;\n            display: grid;\n            grid-template-rows: 1fr;\n            grid-template-columns: 1fr;\n            width: 100%;\n          "], ["\n            position: relative;\n            display: grid;\n            grid-template-rows: 1fr;\n            grid-template-columns: 1fr;\n            width: 100%;\n          "]))),
        ref: (0, components_utils_1.mergeRefs)([fwRef, ref, innerRef])
      }, (0, utils_1.mergeProps)(other, (0, components_utils_1.styleProps)(props)), {
        children: clonedChildren
      }), void 0);
    }
  }), void 0);
}

exports.CarouselFade = (0, react_2.forwardRef)(_CarouselFade);

function _CarouselItem(props, fwRef) {
  return (0, jsx_runtime_1.jsx)("div", __assign({
    css: (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        & img {\n          user-select: none;\n          pointer-events: none;\n          cursor: default;\n        }\n      "], ["\n        & img {\n          user-select: none;\n          pointer-events: none;\n          cursor: default;\n        }\n      "]))),
    ref: fwRef
  }, props), void 0);
}

exports.CarouselItem = (0, react_2.forwardRef)(_CarouselItem);

function _CarouselArrow(props, fwRef) {
  var children = props.children,
      type = props.type,
      _a = props.icon,
      icon = _a === void 0 ? '→' : _a;
  var context = (0, react_2.useContext)(exports.CarouselContext);
  (0, components_utils_1.assertIsDefined)(context, 'CarouselArrowコンポーネントはCarouselコンポーネントの配下に存在する必要があります');
  var controllerRef = context.controllerRef;

  var _b = (0, use_carousel_controller_1.useCarouselController)({
    ref: controllerRef
  }),
      prev = _b.prev,
      next = _b.next;

  return (0, jsx_runtime_1.jsx)(components_button_1.Button, __assign({
    css: (0, react_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        position: absolute;\n        top: 50%;\n\n        &[data-direction='prev'] {\n          left: 0;\n          transform: translateY(-50%) rotate(180deg);\n        }\n\n        &[data-direction='next'] {\n          right: 0;\n          transform: translateY(-50%);\n        }\n      "], ["\n        position: absolute;\n        top: 50%;\n\n        &[data-direction='prev'] {\n          left: 0;\n          transform: translateY(-50%) rotate(180deg);\n        }\n\n        &[data-direction='next'] {\n          right: 0;\n          transform: translateY(-50%);\n        }\n      "]))),
    onPress: function onPress() {
      if (type === 'prev') {
        prev();
      } else {
        next();
      }
    },
    "data-direction": type,
    ref: fwRef
  }, (0, components_utils_1.styleProps)(props), {
    children: children ? children : icon
  }), void 0);
}

exports.CarouselArrow = (0, react_2.forwardRef)(_CarouselArrow);

function _CarouselNavigator(props, fwRef) {
  var children = props.children;
  var context = (0, react_2.useContext)(exports.CarouselContext);
  (0, components_utils_1.assertIsDefined)(context, 'CarouseNavigatorコンポーネントはCarouselコンポーネントの配下に存在する必要があります');
  var controllerRef = context.controllerRef,
      beforeActiveIndex = context.beforeActiveIndex;

  var _a = (0, use_carousel_controller_1.useCarouselController)({
    ref: controllerRef
  }),
      num = _a.num,
      paginateTo = _a.paginateTo;

  var index = (0, components_utils_1.wrapInRange)(beforeActiveIndex, num);
  return (0, jsx_runtime_1.jsx)("div", __assign({
    css: (0, react_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        position: relative;\n        display: flex;\n        gap: var(--c-carousel-navigator-gap, 10px);\n        width: fit-content;\n        margin-top: var(--c-carousel-navigator-margin, 10px);\n        margin-left: auto;\n        margin-right: auto;\n      "], ["\n        position: relative;\n        display: flex;\n        gap: var(--c-carousel-navigator-gap, 10px);\n        width: fit-content;\n        margin-top: var(--c-carousel-navigator-margin, 10px);\n        margin-left: auto;\n        margin-right: auto;\n      "]))),
    ref: fwRef
  }, (0, components_utils_1.styleProps)(props), {
    children: (0, components_utils_1.range)(num).map(function (value) {
      return children ? (0, components_utils_1.runIfFunction)(children, {
        key: value,
        index: value,
        isActive: value === index,
        paginateTo: paginateTo
      }) : (0, jsx_runtime_1.jsx)(exports.CarouselNavigatorItem, {
        index: value,
        isActive: value === index
      }, value);
    })
  }), void 0);
}

exports.CarouselNavigator = (0, react_2.forwardRef)(_CarouselNavigator);

function _CarouselNavigatorItem(props, fwRef) {
  var children = props.children,
      _a = props.index,
      index = _a === void 0 ? 0 : _a,
      isActive = props.isActive;
  var context = (0, react_2.useContext)(exports.CarouselContext);
  (0, components_utils_1.assertIsDefined)(context, 'CarouselNavigatorItemコンポーネントはCarouselコンポーネントの配下に存在する必要があります');
  var controllerRef = context.controllerRef;
  var paginateTo = (0, use_carousel_controller_1.useCarouselController)({
    ref: controllerRef
  }).paginateTo;
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: children ? (0, components_utils_1.useRunIfFunction)(children, (0, utils_1.mergeProps)({
      css: (0, react_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n                color: gray;\n                background-color: currentColor;\n                width: 20px;\n                height: 20px;\n                border-radius: 9999px;\n\n                &[data-active] {\n                  color: inherit;\n                }\n              "], ["\n                color: gray;\n                background-color: currentColor;\n                width: 20px;\n                height: 20px;\n                border-radius: 9999px;\n\n                &[data-active] {\n                  color: inherit;\n                }\n              "]))),
      'data-active': isActive || undefined,
      onPress: function onPress() {
        if (isActive) {
          return;
        }

        paginateTo(index);
      },
      ref: fwRef
    }, (0, components_utils_1.styleProps)(props))) : (0, jsx_runtime_1.jsx)(components_button_1.Button, __assign({
      css: (0, react_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            color: gray;\n            background-color: currentColor;\n            width: 20px;\n            height: 20px;\n            border-radius: 9999px;\n\n            &[data-active] {\n              color: inherit;\n            }\n          "], ["\n            color: gray;\n            background-color: currentColor;\n            width: 20px;\n            height: 20px;\n            border-radius: 9999px;\n\n            &[data-active] {\n              color: inherit;\n            }\n          "]))),
      onPress: function onPress() {
        if (isActive) {
          return;
        }

        paginateTo(index);
      },
      ref: fwRef
    }, (0, utils_1.mergeProps)({
      'data-active': isActive || undefined
    }, (0, components_utils_1.styleProps)(props))), void 0)
  }, void 0);
}

exports.CarouselNavigatorItem = (0, react_2.forwardRef)(_CarouselNavigatorItem);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;